import React, { useEffect, useState } from "react";
import LeftMenu from "../../../components/layout/leftMenu";
import Header from "../../../components/layout/header";
import { useSelector } from "../../../components/hooks/hooks";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import { ToastContainer } from "react-toastify";
import { backendApi } from "../../../api/apiService";
import { useNavigate } from "react-router-dom";

export default function Report() {
    const navigate = useNavigate();
    const { userDetails } = useSelector((state) => state.login);
    const [menuClick, setMenuClick] = useState(false);
    const [vacancyReport, setVacancyReport] = useState([]);
    const [Departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");

    useEffect(() => {
        getSchedulRerecruitmentReports();
    }, []);

    const getSchedulRerecruitmentReports = () => {
        const api = {
            functionName: "departmentReport",
            site_id: userDetails[0].site_id,
            is_active: "1",
        };
        backendApi(api).then((response) => {
            if (response.success === 1) {
                setVacancyReport(response.dataSet);
                setDepartments(response.department);
            }
        });
    };

    const handleBack = () => {
        navigate("/dashboard/analytics-dashboard");
    };

    const handleDepartmentChange = (e) => {
        setSelectedDepartment(e.target.value);
    };

    const filteredReports = selectedDepartment
        ? vacancyReport.filter((job) => job.project_name === selectedDepartment)
        : vacancyReport;

    return (
       
                <>
                    <ToastContainer
                        enableMultiContainer
                        containerId={"D"}
                        position="bottom-right"
                        autoClose={1500}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                    />
                    <div className="">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xxl-12 col-lg-12 col-md-6 padding-left-right-change">
                                    <div className="card main-card-box">
                                        <div className="form-group col-4 dflexClm offset-8">
                                            <label className="form-label">Departments</label>
                                            <select
                                                className="form-control"
                                                value={selectedDepartment}
                                                onChange={handleDepartmentChange}
                                            >
                                                <option value="">-Select-</option>
                                                {Departments.map((department) => (
                                                    <option
                                                        key={department.id}
                                                        value={department.departmentOrProject}
                                                    >
                                                        {department.departmentOrProject}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="card-body">
                                            {/* <h4 className="dash-sub-head">Report</h4> */}
                                            <div className="table-responsive">
                                                <table className="table mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "80px" }}>No</th>
                                                            <th style={{ width: "80px" }}>Summary</th>
                                                            {/* <th style={{ width: "80px" }}>Description</th> */}
                                                            <th style={{ width: "80px" }}>No. of Positions</th>
                                                            <th style={{ width: "130px" }}> Date</th>

                                                            <th style={{ width: "80px" }}>Status</th>
                                                            <th style={{ width: "80px" }}>Department</th>
                                                            <th style={{ width: "80px" }}>Priority</th>
                                                            <th style={{ width: "80px" }}>Experience</th>
                                                            <th style={{ width: "80px" }}>Job Type</th>
                                                            <th style={{ width: "80px" }}>Status</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredReports.length > 0 ? (
                                                            filteredReports.map((job, index) => (
                                                                <tr key={job.id}>
                                                                    <td>{index + 1}</td>
                                                                    <td title={job.description}>{job.summary}</td>
                                                                    {/* <td>{job.description}</td> */}
                                                                    <td>{job.no_of_position}</td>
                                                                    <td>{new Date(job.start_date).toLocaleDateString()} - {new Date(job.end_date).toLocaleDateString()}</td>
                                                                    {/* <td>{new Date(job.end_date).toLocaleDateString()}</td> */}
                                                                    <td>{job.status}</td>
                                                                    <td>{job.project_name}</td>
                                                                    <td>{job.priority}</td>
                                                                    <td>{job.experiance}</td>
                                                                    <td>{job.job_type}</td>
                                                                    <td>
                                                                        {job.recStatus && job.recStatus.length > 0 ? (
                                                                            job.recStatus.map((status, idx) => (
                                                                                <div key={idx}>{status.status_name} <b>({status.cnt})</b></div>
                                                                            ))
                                                                        ) : (
                                                                            <div>No Status</div>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="11">No Openings found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="floating-back-button"
                        onClick={handleBack}
                    >
                        <BsArrowLeftCircleFill size={24} />
                    </button>
                </>
           
    );
}
